/* eslint-disable no-use-before-define */
import React from 'react'
import _ from 'lodash'
import firebase from 'firebase/app'
import { Button, Header, Icon, Grid, Input, Menu } from 'semantic-ui-react'

export default class OnlinePaymentTab extends React.Component {
  state = {
    search: '',
    selectedRestaurantKeys: []
  }

  componentDidMount() {
    const { restaurants } = this.props

    const acceptPaymentOnlineRestaurants = _.pickBy(
      restaurants,
      (restaurant) => (
        restaurant.status === 'publish' &&
        restaurant.branches &&
        Object.values(restaurant.branches)[0].accept_online_payment
      )
    )

    this.setState({ selectedRestaurantKeys: Object.keys(acceptPaymentOnlineRestaurants) })
  }

  onRestaurantClick = async restaurantKey => {
    const { restaurants } = this.props
    const { selectedRestaurantKeys } = this.state

    if (selectedRestaurantKeys.includes(restaurantKey)) {
      this.onRemove(restaurantKey)
    } else {
      this.setState({ selectedRestaurantKeys: selectedRestaurantKeys.concat(restaurantKey) })

      const updates = {}

      _.forEach(restaurants[restaurantKey].branches, (branch, branchKey) => {
        updates[`restaurants/${restaurantKey}/branches/${branchKey}/accept_online_payment`] = true
      })

      await firebase.database().ref().update(updates)
    }
  }

  onRemove = async restaurantKey => {
    const { restaurants } = this.props
    const { selectedRestaurantKeys } = this.state

    this.setState({ selectedRestaurantKeys: selectedRestaurantKeys.filter(key => key !== restaurantKey) })

    const updates = {}
    _.forEach(restaurants[restaurantKey].branches, (branch, branchKey) => {
      updates[`restaurants/${restaurantKey}/branches/${branchKey}/accept_online_payment`] = null
    })

    await firebase.database().ref().update(updates)
  }

  renderRestaurantList = () => {
    const { restaurants } = this.props
    const { selectedRestaurantKeys, search } = this.state

    let displayRestaurants = Object.values(restaurants).filter(restaurant => {
      const restaurantName = (restaurant.name || '').toLowerCase()
      const searchText = search.toLowerCase().trim()

      return restaurant.status === 'publish' && restaurantName.includes(searchText)
    })

    displayRestaurants = _.sortBy(displayRestaurants, 'name')

    return (
      <div>
        <Input
          type="text"
          placeholder="Search"
          name="search-restaurant"
          onChange={e => this.setState({ search: e.target.value })}
          icon="search"
          style={{ width: '100%', marginTop: 10 }}
        />
        <Menu vertical style={styles.menu}>
          {
            displayRestaurants.map(restaurant => (
              <Menu.Item
                key={restaurant.key}
                active={selectedRestaurantKeys && selectedRestaurantKeys.includes(restaurant.key)}
                onClick={() => this.onRestaurantClick(restaurant.key)}
                style={styles.restaurant}
              >
                <div style={styles.restaurantRow} >
                  <div style={styles.restaurantName}>
                    {restaurant.name}
                  </div>
                  {
                    selectedRestaurantKeys.includes(restaurant.key) && (
                      <div style={styles.checkContainer} >
                        <Icon name="check" color="green" />
                      </div>
                    )
                  }
                </div>
              </Menu.Item>
            ))
          }
        </Menu>
      </div>
    )
  }

  renderSelectedRestaurants = () => {
    const { restaurants } = this.props
    const { selectedRestaurantKeys } = this.state

    return (
      <div style={styles.selectedMenu}>
        <Header as='h3' style={{ marginBottom: 22 }}>
          List of Selected Restaurants
        </Header>
        {
          selectedRestaurantKeys.map(restaurantKey => (
            <div style={styles.selectedRestaurantsContainer} key={restaurantKey}>
              <div style={styles.selectedRestaurantsRestaurant}>
                {restaurants[restaurantKey].name}
              </div>
              <div style={{ marginLeft: 8 }}>
                <Button icon="remove" color="red" onClick={() => this.onRemove(restaurantKey)} />
              </div>
            </div>
          ))
        }
      </div>
    )
  }

  render() {
    return (
      <Grid columns={2} style={styles.container}>
        <Grid.Row>
          <Grid.Column>{this.renderRestaurantList()}</Grid.Column>
          <Grid.Column>{this.renderSelectedRestaurants()}</Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}


const styles = {
  container: {
    marginTop: 20
  },
  selectedMenu: {
    marginTop: 20,
    maxHeight: 'calc(100vh - 280px)',
    overflow: 'auto',
    width: '100%'
  },
  menu: {
    maxHeight: 'calc(100vh - 300px)',
    overflow: 'auto',
    width: '100%'
  },
  restaurant: {
    padding: '13px 10px',
    borderRadius: 0
  },
  restaurantRow: {
    flexDirection: 'row',
    alignItems: 'center',
    display: 'flex',
  },
  restaurantName: {
    whiteSpace: 'normal',
    wordBreak: 'break-all',
    lineHeight: '1.3',
    display: 'flex',
    flex: 1,
    fontSize: 15,
  },
  checkContainer: {
    display: 'flex',
    width: 20,
    justifyContent: 'flex-end',
    marginLeft: 5,
  },
  selectedRestaurantsRestaurant: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    userSelect: 'none',
    padding: 10,
    margin: `4px 0 4px 0`,
    background: '#e0e1e2',
    width: '100%',
    borderRadius: `5px`,
    color: 'rgba(0,0,0,.8)',
  },
  selectedRestaurantsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
}




// WEBPACK FOOTER //
// ./src/containers/restaurants/OnlinePaymentTab.js